import Anchor from './Anchor';

export default class Menu {
  constructor() {
    this.DOM = {
      el: document.querySelector('[data-menu="el"]'),
      overlayEl: document.querySelector('[data-menu="overlay"]'),
      openEl: document.querySelector('[data-menu="open"]'),
      closeEl: document.querySelector('[data-menu="close"]')
    }
  }

  init() {
    if (!this.DOM.el || !this.DOM.overlayEl || !this.DOM.openEl || !this.DOM.closeEl) return;
    this.DOM.anchorEls = this.DOM.el.querySelectorAll('.menu__item a');
    this.bindEvents();
    this.initAnchors();
  }

  bindEvents() {
    this.DOM.openEl.addEventListener('click', this.onOpenClick.bind(this));
    this.DOM.closeEl.addEventListener('click', this.onCloseClick.bind(this));
    this.DOM.overlayEl.addEventListener('click', this.onCloseClick.bind(this));
  }

  onOpenClick(e) {
    e.preventDefault();
    this.DOM.el.classList.add('is-open');
    this.DOM.overlayEl.classList.add('is-open');
  }

  onCloseClick(e) {
    e.preventDefault();
    this.DOM.el.classList.remove('is-open');
    this.DOM.overlayEl.classList.remove('is-open');
  }

  initAnchors() {
    const callback = () => {
      this.DOM.el.classList.remove('is-open');
      this.DOM.overlayEl.classList.remove('is-open');
    }

    this.DOM.anchorEls.forEach(el => new Anchor(el, callback));
  }
}